import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Skeleton as AntdSkeleton } from 'antd';
import { SkeletonProps } from 'antd/es/skeleton';
import { SkeletonParagraphProps } from 'antd/es/skeleton/Paragraph';
import { SkeletonInputProps } from 'antd/es/skeleton/Input';
import cx from 'classnames';
import './styles.scss';
export type { SkeletonProps, SkeletonParagraphProps };
const PrefixCls = 'app-skeleton';

/**
 * This class is a wrap around [antd Skeleton](https://ant.design/components/skeleton/) component extending some of
 * the properties to follow our styling guidelines.
 *
 * Please refer to antd documentation for more details.
 *
 */
export function Skeleton(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cx(PrefixCls, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AntdSkeleton {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function SingleLineText(t0) {
  const $ = _c(16);
  let className;
  let props;
  let style;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      fontSize: t1,
      width: t2,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = style;
    $[4] = t1;
    $[5] = t2;
  } else {
    className = $[1];
    props = $[2];
    style = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const fontSize = t1 === undefined ? 14 : t1;
  const width = t2 === undefined ? "100%" : t2;
  const t3 = typeof fontSize === "number" ? `${fontSize}px` : fontSize;
  const t4 = typeof width === "number" ? `${width}px` : width;
  let t5;
  if ($[6] !== style || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      height: t3,
      minWidth: "15px",
      width: t4,
      ...style
    };
    $[6] = style;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== className) {
    t6 = cx(PrefixCls, "app-skeleton-single-line-text", className);
    $[10] = className;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props || $[13] !== t5 || $[14] !== t6) {
    t7 = <AntdSkeleton.Input style={t5} {...props} className={t6} />;
    $[12] = props;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
Skeleton.Avatar = AntdSkeleton.Avatar;
Skeleton.Button = AntdSkeleton.Button;
Skeleton.Image = AntdSkeleton.Image;
Skeleton.Input = AntdSkeleton.Input;
Skeleton.Node = AntdSkeleton.Node;
Skeleton.SingleLineText = SingleLineText;
Skeleton.displayName = AntdSkeleton.displayName;